/**
 * Typography-related semantic tokens for PrimeNG preset
 * Built directly from Figma primitives (no intermediate semantic typography layer)
 */

import * as p from '../tokens/primitives.js';

export const typography = {
  // Typography primitives (exposed for PrimeNG semantic tree)
  fontFamily: {
    base: p.fontFamily.base,
  },
  fontSize: p.fontSize,
  fontWeight: {
    regular: p.fontWeight.normal,
    semibold: p.fontWeight.semibold,
    bold: p.fontWeight.bold,
  },
  lineHeight: {
    normal: p.lineHeight.base,
    ...p.lineHeight,
  },

  // Heading styles — Figma spec: H1=32px, H2=24px, H3=18px, H4=16px; all Bold,
  // Mobile-first: tablet+ (≥768px) uses the base values; mobile uses the nested `mobile` values.
  heading: {
    1: {
      fontSize: p.fontSize['3xl'],     // 32px (tablet+)
      lineHeight: p.lineHeight['4xl'], // 40px (tablet+)
      fontWeight: p.fontWeight.bold,
      fontFamily: p.fontFamily.base,
      letterSpacing: '0%',
      mobile: {
        fontSize: p.fontSize.xl,         // 20px
        lineHeight: p.lineHeight['3xl'], // 32px
      },
    },
    2: {
      fontSize: p.fontSize['2xl'],     // 24px (tablet+)
      lineHeight: p.lineHeight['3xl'], // 32px (tablet+)
      fontWeight: p.fontWeight.bold,
      fontFamily: p.fontFamily.base,
      letterSpacing: '0%',
      mobile: {
        fontSize: p.fontSize.lg,         // 18px
        lineHeight: p.lineHeight['2xl'], // 28px
      },
    },
    3: {
      fontSize: p.fontSize.lg,         // 18px
      lineHeight: p.lineHeight['2xl'], // 28px
      fontWeight: p.fontWeight.semibold,
      fontFamily: p.fontFamily.base,
      letterSpacing: '0%',
    },
    4: {
      fontSize: p.fontSize.base,       // 16px
      lineHeight: p.lineHeight.xl,     // 24px
      fontWeight: p.fontWeight.bold,
      fontFamily: p.fontFamily.base,
      letterSpacing: '0%',
    },
  },
  body: {
    regular: {
      md: {
        fontSize: p.fontSize.base,      // 16px
        lineHeight: p.lineHeight.xl,    // 24px (1.5 ratio)
        fontWeight: p.fontWeight.normal,
        fontFamily: p.fontFamily.base,
        letterSpacing: '0%',
      },
      base: {
        fontSize: p.fontSize.sm,        // 14px
        lineHeight: p.lineHeight.lg,    // 20px (1.43 ratio)
        fontWeight: p.fontWeight.normal,
        fontFamily: p.fontFamily.base,
        letterSpacing: '0%',
      },
      s: {
        fontSize: p.fontSize.xs,        // 12px
        lineHeight: p.lineHeight.base,  // 16px (1.33 ratio)
        fontWeight: p.fontWeight.normal,
        fontFamily: p.fontFamily.base,
        letterSpacing: '0%',
      },
    },
    bold: {
      md: {
        fontSize: p.fontSize.base,      // 16px
        lineHeight: p.lineHeight.xl,    // 24px (1.5 ratio)
        fontWeight: p.fontWeight.bold,
        fontFamily: p.fontFamily.base,
        letterSpacing: '0%',
      },
      base: {
        fontSize: p.fontSize.sm,        // 14px
        lineHeight: p.lineHeight.lg,    // 20px (1.43 ratio)
        fontWeight: p.fontWeight.bold,
        fontFamily: p.fontFamily.base,
        letterSpacing: '0%',
      },
      s: {
        fontSize: p.fontSize.xs,        // 12px
        lineHeight: p.lineHeight.base,  // 16px (1.33 ratio)
        fontWeight: p.fontWeight.bold,
        fontFamily: p.fontFamily.base,
        letterSpacing: '0%',
      },
    },
    semibold: {
      base: {
        fontSize: p.fontSize.base,      // 16px
        lineHeight: p.lineHeight.xl,    // 24px (1.5 ratio)
        fontWeight: p.fontWeight.semibold,
        fontFamily: p.fontFamily.base,
        letterSpacing: '0%',
      },
      s: {
        fontSize: p.fontSize.sm,        // 14px
        lineHeight: p.lineHeight.lg,    // 20px (1.43 ratio)
        fontWeight: p.fontWeight.semibold,
        fontFamily: p.fontFamily.base,
        letterSpacing: '0%',
      },
    },
  },
  textButton: {
    fontSize: p.fontSize.base,          // 16px
    lineHeight: p.lineHeight.lg,        // 20px (compact for buttons)
    fontWeight: p.fontWeight.semibold,
    fontFamily: p.fontFamily.base,
    letterSpacing: '0%',
  },
  caption: {
    regular: {
      fontSize: p.fontSize.xs,          // 12px
      lineHeight: p.lineHeight.base,    // 16px (1.33 ratio)
      fontWeight: p.fontWeight.normal,
      fontFamily: p.fontFamily.base,
      letterSpacing: '0%',
    },
    bold: {
      fontSize: p.fontSize.xs,          // 12px
      lineHeight: p.lineHeight.base,    // 16px (1.33 ratio)
      fontWeight: p.fontWeight.bold,
      fontFamily: p.fontFamily.base,
      letterSpacing: '0%',
    },
  },
};
